<template>
  <div class="services">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <!-- Slides -->
    <div class="internal-page-slides">
      <div
        v-for="(slide, index) of slidesArray"
        :key="index"
        class="internal-page-slide">
        <InternalTitleDescriptionImageParallax
          :images="slide.images"
          :contents="slide.contents"
          :contentLeft="slide.contentLeft"
          :rellaxSpeed="rellaxSpeed"/>
      </div>
    </div>
    <!-- si affidano a noi -->
    <div class="our-customers" style="display: none">
      <h3>{{ $t('services.fidelity') }}</h3>
      <ul>
        <li><img src="@/assets/services/logo-autogrill.png"></li>
        <li><img src="@/assets/services/logo-ferrovie-italiane.png"></li>
        <li><img src="@/assets/services/logo-autogrill.png"></li>
        <li><img src="@/assets/services/logo-ferrovie-italiane.png"></li>
        <li><img src="@/assets/services/logo-autogrill.png"></li>
        <li><img src="@/assets/services/logo-ferrovie-italiane.png"></li>
      </ul>
    </div>
    <!-- come funziona -->
    <div class="how-it-works">
      <h2 v-html="$t('services.howItWorks')"></h2>
      <ul>
        <li>
          <img src="@/assets/icons/ic-bread.svg">
          <p v-html="$t('services.discover')"></p>
        </li>
        <li>
          <img src="@/assets/icons/ic-wishlist.svg">
          <p v-html="$t('services.wishlist')"></p>
        </li>
        <li>
          <img src="@/assets/icons/ic-send-mail.svg">
          <p v-html="$t('services.getQuote')"></p>
        </li>
      </ul>
      <div class="how-it-works__cta">
        <button 
          v-html="$t('services.discover2')"
          @click="$_discoverAssortment">
        </button>
      </div>
    </div>
    <glaxiFooter/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import InternalTitleDescriptionImageParallax from '@/components/InternalTitleDescriptionImageParallax/InternalTitleDescriptionImageParallax.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'
import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'Services',
  mixins: [matchMedia],
  components: {
    HeroText,
    InternalTitleDescriptionImageParallax,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    slidesArrayIt: [
      {
        images: [
          {
            'landscape': require('@/assets/services/services-01-landscape.jpg'),
            'portrait': require('@/assets/services/services-01-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Ingredienti 100% genuini.',
            description: 'Per il nostro pane scegliamo solo ingredienti genuini e di elevatissima qualità. Abbiamo detto NO a olio di palma, grassi idrogenati e coloranti artificiali.',
            label: 'Cosa significa per te',
            labelContent: 'Fare la differenza. Che tu sia un barista, un ristoratore, un grossista o un trasformatore puoi proporre un pane dalle caratteristiche uniche, la cui genuinità e freschezza si vede e si sente da subito.'
          },
          {
            title: 'Pane per tutti i denti',
            description: 'Conosciamo bene le richieste odierne del mercato dei panificati. Per questo abbiamo creato un assortimento composto da più di 130 prodotti, con la continua introduzione di nuove specialità. Dal pane per tramezzini, a quello per hamburger, dalle baguette ai panini morbidi, dalla linea vegan alle proposte colorate e moltissimo altro.<br> Per soddisfare tutti i gusti.',
            label: 'Cosa significa per te',
            labelContent: 'Infinite possibilità di abbinamenti creativi, una proposta sempre varia e in linea con le ultime tendenze in ambito di panificati.'
          }
        ],
        contentLeft: true
      },
      {
        images: [
          {
            'landscape': require('@/assets/services/services-02-landscape.jpg'),
            'portrait': require('@/assets/services/services-02-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Il congelamento come miglior alleato della tua attività.',
            description: 'Sappiamo quanto sia importante per baristi e ristoratori avere sempre a disposizione prodotti che possano essere preparati in breve tempo, garantendo, al contempo, la qualità del pane. Per questo abbiamo scelto il congelamento per i nostri panificati. Per offrirti un prodotto sempre pronto all’uso con le stesse caratteristiche di quello appena sfornato.',
            label: 'Cosa significa per te',
            labelContent: 'Massima efficienza, nessuna rimanenza. Basta sprechi di pane fresco o prodotti con conservanti che alterano il profumo e il gusto dei panificati. Hai tutta la qualità e la comodità che cerchi e ottimizzi tempo e risorse.'
          },
          {
            title: 'Il connubio vincente tra tradizione e tecnologia.',
            description: 'Uniamo le sapienti tradizioni e le ricette di famiglia all’organizzazione e ai rigorosi processi di una grande industria.',
            label: 'Cosa significa per te',
            labelContent: 'Scegliere un prodotto che assicura sempre standard qualitativi elevati, con la stessa fragranza e bontà del forno sotto casa.'
          }
        ],
        contentLeft: false
      },
      {
        images: [
          {
            'landscape': require('@/assets/services/services-03-landscape.jpg'),
            'portrait': require('@/assets/services/services-03-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Possibilità<br> di personalizzazione.',
            description: 'Abbiamo gli strumenti e l’esperienza per supportarti nella creazione di prodotti su misura. Ideiamo nuove ricette, partendo dagli ingredienti desiderati per creare panificati unici e personalizzati.',
            label: 'Cosa significa per te',
            labelContent: 'Poter contare su un partner che ti aiuta a realizzare nuovi progetti nell’ambito dei panificati.'
          },
          {
            title: 'Produzione flessibile.',
            description: 'Le caratteristiche peculiari dei nostri processi produttivi ci permettono di venire incontro alle richieste dei nostri clienti, in termini di quantità e tempistiche di produzione del prodotto.',
            label: 'Cosa significa per te',
            labelContent: 'Affidarti a un partner di fiducia che ascolta sempre le tue richieste e si impegna nel trovare una soluzione che risponda alle tue necessità.'
          },
          {
            title: 'Il valore delle certificazioni.',
            description: 'La nostra azienda è certificata ISO 9001:2015, IFS (INTERNATIONAL FOOD STANDARD) ed è autorizzata alla produzione biologica. Inoltre tutti i nostri processi produttivi sono guidati dagli standard HACCP.',
            label: 'Cosa significa per te',
            labelContent: 'Poter contare su un fornitore certificato il cui impegno e lavoro costante si traduce in prodotti sicuri e sempre all’altezza.'
          }
        ],
        contentLeft: true
      }
    ],
    slidesArrayEn: [
      {
        images: [
          {
            'landscape': require('@/assets/services/services-01-landscape.jpg'),
            'portrait': require('@/assets/services/services-01-portrait.jpg')
          }
        ],
        contents: [
          {
            title: '100% genuine ingredients.',
            description: 'For our bread we choose only the most genuine ingredients of the highest quality. We said NO to palm oil, hydrogenated fats and artificial colours.',
            label: 'What that means to you',
            labelContent: 'It means making the difference. Whether you\'re a bartender, a caterer, a wholesaler or a transformer of food, you can propose a bread with unique characteristics, whose authenticity and freshness is immediately seen and felt.'
          },
          {
            title: 'Bread for all tastes',
            description: 'We are fully aware of the requests today\'s market makes concerning bread products. We have created an assortment of more than 130 different products, with the continuous introduction of new specialities. From bread for tramezzini, to hamburger buns, from baguettes to soft rolls, from the vegan line to the most colourful proposals and so much more.<br> To satisfy all tastes.',
            label: 'What that means to you',
            labelContent: 'Infinite possibilities for creative combinations, a proposal that is always varied and in line with the latest trends in the bread sector.'
          }
        ],
        contentLeft: true
      },
      {
        images: [
          {
            'landscape': require('@/assets/services/services-02-landscape.jpg'),
            'portrait': require('@/assets/services/services-02-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Freezing as your company\'s best ally.',
            description: 'We know how important it is for bartenders and restaurant owners to have products that can be prepared rapidly, while at the same time ensuring the quality of the bread. For this reason we have chosen to use freezing for our bread products. To offer you a product that is always ready for use with the same characteristics as that of freshly baked bread.',
            label: 'What that means to you',
            labelContent: 'Maximum efficiency, no left-overs. You will say goodbye to the waste of fresh bread or to products with preservatives that alter the aroma and taste of your bread. You have all the quality and convenience you are looking for, while optimising time and resources.'
          },
          {
            title: 'The winning combination of tradition and technology.',
            description: 'We combine the skilfulness of traditions and family recipes with the organisation and rigorous processes of a large industry.',
            label: 'What does it mean to you',
            labelContent: 'You can choose a product that always ensures high quality standards, with the same fragrance and goodness of the neighbourhood bakery.'
          }
        ],
        contentLeft: false
      },
      {
        images: [
          {
            'landscape': require('@/assets/services/services-03-landscape.jpg'),
            'portrait': require('@/assets/services/services-03-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Customisation options.',
            description: 'We have the tools and experience to support you in the creation of customised products. We invent new recipes, starting with the desired ingredients, to create unique and customised bread products.',
            label: 'What that means to you',
            labelContent: 'So that you can count on a partner that helps you create new projects as part of your bread offer.'
          },
          {
            title: 'Flexible production.',
            description: 'The peculiar characteristics of our production processes enable us to meet the demands of our customers, in terms of quantity and timing of the products\' production.',
            label: 'What that means to you',
            labelContent: 'Rely on a trusted partner who always listens to your demands and who is committed to finding a solution that best responds to your needs.'
          },
          {
            title: 'The value of certification.',
            description: 'Our company is certified ISO 9001: 2015, IFS (INTERNATIONAL FOOD STANDARD) and is authorised for organic production. Moreover, all of our production processes are driven by the HACCP standards.',
            label: 'What that means to you',
            labelContent: 'You can count on a certificated supplier whose commitment and constant work is translated into products that are safe and always up to expectations.'
          }
        ],
        contentLeft: true
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'lang'
    ]),
    rellaxSpeed: {
      get () {
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'small') return 0
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'medium') return -3
        return -2
      }
    },
    slidesArray: {
      get () {
        if (this.lang === undefined) return undefined
        if (this.lang === 'it') return this.slidesArrayIt
        return this.slidesArrayEn
      }
    }
  },
  methods: {
    $_discoverAssortment () {
      this.$emit('open-categories')
    }
  }
}
</script>

<style lang="scss">
  @import "./services.scss";
</style>
